<ng-container
  *ngIf="{
      paymentMethodMode: paymentMethodMode$ | async,
      temporaryPaymentMethod: temporaryPaymentMethod$ | async,
      intent: intent$ | async,
      paymentFlow: paymentFlow$ | async
    } as data"
>
  <!-- saved payment methods -->
  <app-stripe-select-saved-payment-method
    *ngIf="showSavedPaymentMethods$ | async"
    [paymentMethodMode]="data.paymentMethodMode"
    [selectedPaymentMethodId]="selectedPaymentMethodId$ | async"
    (paymentMethodModeChange)="paymentMethodModeChange.emit($event)"
    (paymentMethodSelected)="paymentMethodSelected.emit($event)"
    (updateBillingAddress)="onUpdateBillingAddress($event)"
  ></app-stripe-select-saved-payment-method>

  <!-- Email-first gate status banner, shown above the creation area (saved methods above stay outside the
       gate and remain selectable). The per-option locking lives on the new-method-type options. -->
  <app-payment-method-gate
    [active]="emailGateActive()"
    [locked]="emailGateLocked()"
    [prepopulated]="emailGatePrepopulated()"
  ></app-payment-method-gate>

  <!-- temporary payment method -->
  <ng-container
    *ngIf="
      data.intent === PaymentMethodIntent.PAYMENT && data.paymentFlow === PaymentFlow.STANDARD && data.temporaryPaymentMethod;
      else selectNewPaymentMethodTypeTemplate
    "
  >
    <div
      class="d-flex align-items-center p-4 mt-2 cursor-pointer payment-method-mode-container"
      [ngClass]="{ 'payment-method-mode-container-selected': data.paymentMethodMode === PaymentMethodMode.TEMPORARY }"
      (click)="paymentMethodModeChange.emit(PaymentMethodMode.TEMPORARY)"
      data-cy="payment-method-mode-container-temporary"
    >
      <img [src]="data.temporaryPaymentMethod.icon" width="16" height="16" alt="" class="me-2">

      <p class="body-600 flex-fill">
        {{ data.temporaryPaymentMethod.name }} •••• {{ data.temporaryPaymentMethod.lastFour }}
      </p>

      <button
        andButton
        color="ghost"
        size="small"
        class="border-0"
        (click)="removeTemporaryPaymentMethod($event)"
        data-cy="remove-temporary-payment-method-button"
      >
        <aiwyn-icon name="x" role="button"></aiwyn-icon>
      </button>
    </div>

    <button
      andButton
      size="small"
      color="ghost-secondary"
      class="mt-2"
      (click)="onNewPaymentMethodTypeSelected()"
      data-cy="edit-payment-method-button"
    >
      Edit payment method...
    </button>
  </ng-container>

  <!-- new payment method types -->
  <ng-template #selectNewPaymentMethodTypeTemplate>
    <div *ngIf="(setupIntentClientSecretStatus$ | async) === LoadableStatus.ERROR" class="alert alert--error mt-4">
      Sorry, we are unable to configure payment method creation. Please try again later.
    </div>

    <app-stripe-select-new-payment-method-type
      [paymentMethodDisplayNames]="paymentMethodDisplayNames$ | async"
      [locked]="emailGateActive() && emailGateLocked()"
      class="mt-2"
      (selectedPaymentMethodType)="onNewPaymentMethodTypeSelected($event)"
      (lockedAttempt)="lockedNewMethodAttempt.emit()"
    >
    </app-stripe-select-new-payment-method-type>
  </ng-template>

  <!-- set up later -->
  <mat-accordion #setUpLaterAccordion='matAccordion' *ngIf="showSetUpLater$ | async" class="d-block mt-2 payment-method-option-accordion">
    <mat-expansion-panel
      class="set-up-later-expansion-panel"
      hideToggle
      [expanded]="data.paymentMethodMode === PaymentMethodMode.SET_UP_LATER"
      (opened)="paymentMethodModeChange.emit(PaymentMethodMode.SET_UP_LATER)"
      data-cy="payment-method-mode-container-set-up-later"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <aiwyn-icon name="clock" height="20" width="20" class="d-inline me-6"></aiwyn-icon>
          Set up later
        </mat-panel-title>
      </mat-expansion-panel-header>

      <p>
        You will be required to provide your payment information when paying your bill.
        Or, speed up this process by entering your payment information now.
      </p>
    </mat-expansion-panel>
  </mat-accordion>
</ng-container>
